import React from 'react';
import { homeObjOne, homeObjTwo, homeObjThree, homeObjFour } from './Data';
import { InfoSection, Pricing } from '../../components';

function Home() {
  return (
    <>
      <InfoSection {...homeObjOne} />
      <div id='our-functionality'>
        <InfoSection {...homeObjTwo} />
      </div>

      <div id='our-clients'>
        <InfoSection  {...homeObjThree} />
      </div>

      <Pricing />
      <div id='our-security'>
        <InfoSection {...homeObjFour} />
      </div>
    </>
  );
}

export default Home;
